import { render, staticRenderFns } from "./ResumeListBox.vue?vue&type=template&id=0bb6ecd2&"
import script from "./ResumeListBox.vue?vue&type=script&lang=js&"
export * from "./ResumeListBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports